import { useState } from "react";
import { CheckCircle, XCircle, Clock, Phone, ChevronRight } from "lucide-react";

// ============================================================
// VUE 1 : CE QUE LE CLIENT VOIT (son téléphone)
// ============================================================
const ClientView = () => {
  const [confirmed, setConfirmed] = useState(null);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-900 flex flex-col items-center py-8 px-4">
      <div className="w-full max-w-md space-y-4">

        {/* Header */}
        <div className="text-center mb-6">
          <div className="w-14 h-14 rounded-2xl bg-white/10 border border-white/20 flex items-center justify-center mx-auto mb-3">
            <span className="text-white font-bold">TC</span>
          </div>
          <h1 className="text-white font-bold text-xl">TopCocoon</h1>
          <p className="text-indigo-300 text-sm">Suivi de votre livraison</p>
        </div>

        {/* Statut */}
        <div className="bg-indigo-500/10 border border-indigo-400/30 rounded-2xl p-5">
          <p className="text-white/60 text-xs uppercase tracking-widest mb-1">Livraison prévue</p>
          <p className="text-white font-bold text-lg">Samedi 1 mars</p>
          <p className="text-indigo-300 text-2xl font-bold mt-1">Entre 10h15 et 10h35</p>
          <p className="text-white/50 text-sm mt-2">📍 Mortinsart 21c, 6740 Etalle</p>
          <p className="text-white/50 text-sm">🪑 6x Chaise Milan Black — 235 €</p>
        </div>

        {/* BLOC CONFIRMATION */}
        {confirmed === null && (
          <div className="bg-white/5 border border-white/10 rounded-2xl p-5">
            <p className="text-white font-semibold mb-1">Confirmez-vous votre présence ?</p>
            <p className="text-white/50 text-sm mb-4">Cela aide le livreur à organiser sa tournée.</p>
            <div className="grid grid-cols-2 gap-3">
              <button
                onClick={() => setConfirmed(true)}
                className="flex flex-col items-center gap-2 p-4 bg-green-500/20 border border-green-400/30 rounded-xl hover:bg-green-500/30 transition-all"
              >
                <CheckCircle className="w-8 h-8 text-green-400" />
                <span className="text-green-300 font-semibold text-sm">Je serai là</span>
              </button>
              <button
                onClick={() => setConfirmed(false)}
                className="flex flex-col items-center gap-2 p-4 bg-red-500/20 border border-red-400/30 rounded-xl hover:bg-red-500/30 transition-all"
              >
                <XCircle className="w-8 h-8 text-red-400" />
                <span className="text-red-300 font-semibold text-sm">Je serai absent</span>
              </button>
            </div>
          </div>
        )}

        {confirmed === true && (
          <div className="bg-green-500/10 border border-green-400/30 rounded-2xl p-5 text-center">
            <CheckCircle className="w-10 h-10 text-green-400 mx-auto mb-2" />
            <p className="text-green-300 font-bold">Présence confirmée !</p>
            <p className="text-white/50 text-sm mt-1">Le livreur vous contactera 30 min avant.</p>
          </div>
        )}

        {confirmed === false && (
          <div className="bg-orange-500/10 border border-orange-400/30 rounded-2xl p-5 text-center">
            <XCircle className="w-10 h-10 text-orange-400 mx-auto mb-2" />
            <p className="text-orange-300 font-bold">Absence signalée</p>
            <p className="text-white/50 text-sm mt-1">TopCocoon vous recontactera pour reprogrammer.</p>
          </div>
        )}

        {/* Facebook */}
        <a href="#" className="w-full flex items-center justify-between p-4 bg-white/5 border border-white/10 rounded-2xl">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-blue-600 flex items-center justify-center">
              <span className="text-white text-xs font-bold">f</span>
            </div>
            <p className="text-white text-sm font-medium">Laisser un avis</p>
          </div>
          <ChevronRight className="w-4 h-4 text-white/30" />
        </a>

        <p className="text-center text-white/20 text-xs">TopCocoon • Livraison de mobilier</p>
      </div>
    </div>
  );
};

// ============================================================
// VUE 2 : CE QUE TOI TU VOIS (ton dashboard)
// ============================================================
const AdminView = () => {
  const clients = [
    { nom: "Karima Mouradi",    heure: "10h15", statut: "confirme",  tel: "0470123456", commande: "2x Milan Noir" },
    { nom: "Julie Gruslin",     heure: "10h35", statut: "confirme",  tel: "0471234567", commande: "4x Milan Sand" },
    { nom: "Jean-Pierre Dubois",heure: "10h55", statut: "absent",    tel: "0472345678", commande: "1x Louis Transparent" },
    { nom: "Monika Passarelli", heure: "11h15", statut: "en_attente",tel: "0473456789", commande: "6x Milan Black" },
    { nom: "Thomas Laurent",    heure: "11h35", statut: "en_attente",tel: "0474567890", commande: "2x Milan Rose" },
  ];

  const confirmes   = clients.filter(c => c.statut === "confirme").length;
  const absents     = clients.filter(c => c.statut === "absent").length;
  const enAttente   = clients.filter(c => c.statut === "en_attente").length;

  return (
    <div className="min-h-screen bg-slate-50 p-4">
      <div className="max-w-lg mx-auto space-y-4">

        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-slate-800 font-bold text-xl">Confirmations</h2>
            <p className="text-slate-500 text-sm">Tournée samedi 1 mars</p>
          </div>
          <button className="bg-indigo-600 text-white px-4 py-2 rounded-xl text-sm font-medium">
            SMS en masse
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-3">
          <div className="bg-green-50 border border-green-200 rounded-xl p-3 text-center">
            <p className="text-green-700 font-bold text-2xl">{confirmes}</p>
            <p className="text-green-600 text-xs">Confirmés</p>
          </div>
          <div className="bg-red-50 border border-red-200 rounded-xl p-3 text-center">
            <p className="text-red-700 font-bold text-2xl">{absents}</p>
            <p className="text-red-600 text-xs">Absents</p>
          </div>
          <div className="bg-orange-50 border border-orange-200 rounded-xl p-3 text-center">
            <p className="text-orange-700 font-bold text-2xl">{enAttente}</p>
            <p className="text-orange-600 text-xs">En attente</p>
          </div>
        </div>

        {/* Liste clients */}
        <div className="space-y-2">
          {clients.map((c, i) => (
            <div key={i} className={`flex items-center gap-3 p-4 rounded-xl border bg-white ${
              c.statut === "confirme"  ? "border-green-200" :
              c.statut === "absent"   ? "border-red-200" :
                                        "border-slate-200"
            }`}>
              {/* Heure */}
              <span className="text-slate-400 text-xs font-mono w-10 flex-shrink-0">{c.heure}</span>

              {/* Icône statut */}
              {c.statut === "confirme"  && <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0" />}
              {c.statut === "absent"    && <XCircle     className="w-6 h-6 text-red-500 flex-shrink-0" />}
              {c.statut === "en_attente"&& <Clock       className="w-6 h-6 text-orange-400 flex-shrink-0" />}

              {/* Infos */}
              <div className="flex-1 min-w-0">
                <p className="text-slate-800 font-semibold text-sm truncate">{c.nom}</p>
                <p className="text-slate-400 text-xs truncate">{c.commande}</p>
              </div>

              {/* Bouton appel (si absent ou en attente) */}
              {c.statut !== "confirme" && (
                <button className="w-9 h-9 rounded-xl bg-indigo-100 flex items-center justify-center flex-shrink-0">
                  <Phone className="w-4 h-4 text-indigo-600" />
                </button>
              )}
            </div>
          ))}
        </div>

        <p className="text-center text-slate-400 text-xs pb-4">
          Cliquer sur le téléphone pour appeler directement
        </p>
      </div>
    </div>
  );
};

// ============================================================
// PAGE DE DEMO (les deux côte à côte)
// ============================================================
const SchemaDemo = () => {
  const [view, setView] = useState("admin");

  return (
    <div>
      {/* Toggle */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-slate-800 flex">
        <button
          onClick={() => setView("admin")}
          className={`flex-1 py-3 text-sm font-medium transition-all ${view === "admin" ? "bg-indigo-600 text-white" : "text-white/50"}`}
        >
          TON DASHBOARD
        </button>
        <button
          onClick={() => setView("client")}
          className={`flex-1 py-3 text-sm font-medium transition-all ${view === "client" ? "bg-indigo-600 text-white" : "text-white/50"}`}
        >
          VUE CLIENT
        </button>
      </div>
      <div className="pt-11">
        {view === "admin" ? <AdminView /> : <ClientView />}
      </div>
    </div>
  );
};

export default SchemaDemo;
